/* CraftSupply: mobile helpers (sticky add-to-cart on product pages, swipe hint for wide tables). */
(function () {
  var isZh = (document.documentElement.lang || '').toLowerCase().indexOf('zh') === 0;
  var mq = window.matchMedia('(max-width: 749px)');

  function tableHints() {
    document.querySelectorAll('.article-template__content table, .rte table').forEach(function (t) {
      if (t.dataset.csHint) return;
      t.dataset.csHint = '1';
      if (t.scrollWidth <= t.clientWidth + 4) return;
      var hint = document.createElement('span');
      hint.className = 'cs-table-hint';
      hint.textContent = isZh ? '← 左右滑動查看完整表格 →' : '← Swipe to see the full table →';
      t.parentNode.insertBefore(hint, t.nextSibling);
    });
  }

  function stickyAtc() {
    var info = document.querySelector('.product__info-container');
    var submit = info && info.querySelector('product-form .product-form__submit');
    if (!submit || document.querySelector('.cs-sticky-atc')) return;
    var titleEl = info.querySelector('.product__title h1, .product__title h2');
    var bar = document.createElement('div');
    bar.className = 'cs-sticky-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', isZh ? '快速加入購物車' : 'Quick add to cart');
    bar.innerHTML = '<div class="cs-sticky-atc__info"><div class="cs-sticky-atc__title"></div><div class="cs-sticky-atc__price"></div></div><button type="button" class="button button--primary"></button>';
    document.body.appendChild(bar);
    var t = bar.querySelector('.cs-sticky-atc__title');
    var p = bar.querySelector('.cs-sticky-atc__price');
    var b = bar.querySelector('button');

    function sync() {
      t.textContent = titleEl ? titleEl.textContent.trim() : '';
      var price = info.querySelector('.price .price-item--sale:not(.price-item--last)') ||
        info.querySelector('.price__sale .price-item--sale') || info.querySelector('.price .price-item--regular');
      var priceBox = info.querySelector('.price');
      var visiblePrice = '';
      if (priceBox) {
        var items = priceBox.querySelectorAll('.price-item');
        for (var i = 0; i < items.length; i++) {
          if (items[i].offsetParent !== null && items[i].textContent.trim()) {
            visiblePrice = items[i].textContent.trim();
            if (items[i].classList.contains('price-item--sale')) break;
          }
        }
      }
      p.textContent = visiblePrice || (price ? price.textContent.trim() : '');
      var label = submit.querySelector('span');
      b.textContent = (label ? label.textContent : submit.textContent).trim();
      b.disabled = submit.disabled;
    }
    sync();
    new MutationObserver(sync).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });

    b.addEventListener('click', function () {
      if (submit.disabled) return;
      submit.click();
    });

    var io = new IntersectionObserver(function (entries) {
      var show = mq.matches && !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('cs-has-sticky-atc', show);
    });
    io.observe(submit);
  }

  function init() { tableHints(); stickyAtc(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
